// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let NotificationSettingsComponents = require("./NotificationSettingsComponents.bs.js");
let NotificationSettingsPreferenceEditDialog = require("./NotificationSettingsPreferenceEditDialog.bs.js");
let NotificationSettingsBuyerNeeds_chapter_graphql = require("../../__generated__/NotificationSettingsBuyerNeeds_chapter_graphql.bs.js");
let NotificationSettingsBuyerNeeds_notificationSetting_graphql = require("../../__generated__/NotificationSettingsBuyerNeeds_notificationSetting_graphql.bs.js");
let NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation_graphql = require("../../__generated__/NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation_graphql.bs.js");

let forSalePropertyTypeEnumV5_decode = NotificationSettingsBuyerNeeds_notificationSetting_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let convertFragment = NotificationSettingsBuyerNeeds_notificationSetting_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsBuyerNeeds_notificationSetting_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsBuyerNeeds_notificationSetting_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsBuyerNeeds_notificationSetting_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsBuyerNeeds_notificationSetting_graphql.node, convertFragment, fRef);
}

let NotificationSettingFragment_forSalePropertyTypeEnumV5_fromString = NotificationSettingsBuyerNeeds_notificationSetting_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let NotificationSettingFragment = {
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: NotificationSettingFragment_forSalePropertyTypeEnumV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = NotificationSettingsBuyerNeeds_chapter_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsBuyerNeeds_chapter_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsBuyerNeeds_chapter_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsBuyerNeeds_chapter_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsBuyerNeeds_chapter_graphql.node, convertFragment$1, fRef);
}

let ChapterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertVariables = NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation_graphql.Internal.convertVariables;

let convertResponse = NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables, NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let UpdateUserNotificationSettingsV5Mutation_broadcastMessageNotificationPreferenceSettingV5_decode = NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.broadcastMessageNotificationPreferenceSettingV5_decode;

let UpdateUserNotificationSettingsV5Mutation_broadcastMessageNotificationPreferenceSettingV5_fromString = NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.broadcastMessageNotificationPreferenceSettingV5_fromString;

let UpdateUserNotificationSettingsV5Mutation_developmentNotificationPreferenceSettingV5_decode = NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.developmentNotificationPreferenceSettingV5_decode;

let UpdateUserNotificationSettingsV5Mutation_developmentNotificationPreferenceSettingV5_fromString = NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.developmentNotificationPreferenceSettingV5_fromString;

let UpdateUserNotificationSettingsV5Mutation_entityNotificationPreferenceSettingV5_decode = NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.entityNotificationPreferenceSettingV5_decode;

let UpdateUserNotificationSettingsV5Mutation_entityNotificationPreferenceSettingV5_fromString = NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.entityNotificationPreferenceSettingV5_fromString;

let UpdateUserNotificationSettingsV5Mutation = {
  broadcastMessageNotificationPreferenceSettingV5_decode: UpdateUserNotificationSettingsV5Mutation_broadcastMessageNotificationPreferenceSettingV5_decode,
  broadcastMessageNotificationPreferenceSettingV5_fromString: UpdateUserNotificationSettingsV5Mutation_broadcastMessageNotificationPreferenceSettingV5_fromString,
  developmentNotificationPreferenceSettingV5_decode: UpdateUserNotificationSettingsV5Mutation_developmentNotificationPreferenceSettingV5_decode,
  developmentNotificationPreferenceSettingV5_fromString: UpdateUserNotificationSettingsV5Mutation_developmentNotificationPreferenceSettingV5_fromString,
  entityNotificationPreferenceSettingV5_decode: UpdateUserNotificationSettingsV5Mutation_entityNotificationPreferenceSettingV5_decode,
  entityNotificationPreferenceSettingV5_fromString: UpdateUserNotificationSettingsV5Mutation_entityNotificationPreferenceSettingV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$2
};

function NotificationSettingsBuyerNeeds(props) {
  let onFailed = props.onFailed;
  let onSuccess = props.onSuccess;
  let chapter = RescriptRelay_Fragment.useFragment(NotificationSettingsBuyerNeeds_chapter_graphql.node, convertFragment$1, props.chapter);
  let notificationSetting = RescriptRelay_Fragment.useFragment(NotificationSettingsBuyerNeeds_notificationSetting_graphql.node, convertFragment, props.notificationSetting);
  let match = use$2();
  let updateUserNotificationSettings = match[0];
  let match$1 = React.useState(() => false);
  let setIsEditing = match$1[1];
  let isEditing = match$1[0];
  let hasGNSFeature = UserSession.useHasPlanFeature("GNS");
  let match$2 = React.useState(() => false);
  let setShowUpgradeDialog = match$2[1];
  let match$3 = notificationSetting.buyerNeeds;
  let selectedSetting;
  if (match$3 !== undefined) {
    switch (match$3.__typename) {
      case "ChapterDefaultNotificationSetting" :
        selectedSetting = "CHAPTER_DEFAULT";
        break;
      case "CustomClientNeedNotificationPreference" :
        selectedSetting = "CUSTOM";
        break;
      case "MatchesOnlyNotificationSetting" :
        selectedSetting = "MATCH_ONLY";
        break;
      case "__unselected" :
        selectedSetting = undefined;
        break;
    }
  } else {
    selectedSetting = undefined;
  }
  let match$4 = notificationSetting.buyerNeeds;
  let userHasInactiveCustomPreference;
  if (match$4 !== undefined) {
    switch (match$4.__typename) {
      case "ChapterDefaultNotificationSetting" :
      case "MatchesOnlyNotificationSetting" :
        userHasInactiveCustomPreference = match$4.userHasInactiveCustomPreference;
        break;
      case "CustomClientNeedNotificationPreference" :
      case "__unselected" :
        userHasInactiveCustomPreference = false;
        break;
    }
  } else {
    userHasInactiveCustomPreference = false;
  }
  if (selectedSetting === undefined) {
    return null;
  }
  let match$5 = notificationSetting.buyerNeeds;
  let preferenceData = match$5 !== undefined && match$5.__typename === "CustomClientNeedNotificationPreference" ? ({
      areaGroup: match$5.areaGroup,
      maxPrice: match$5.maxPrice,
      minPrice: match$5.minPrice,
      propertyTypes: match$5.propertyTypes,
      fragmentRefs: match$5.fragmentRefs
    }) : undefined;
  let tmp;
  if (preferenceData !== undefined) {
    let areaGroup = preferenceData.areaGroup;
    tmp = areaGroup !== undefined ? JsxRuntime.jsx(NotificationSettingsComponents.PreferenceSummary.make, {
        tanType: "ForSale",
        minPrice: preferenceData.minPrice,
        maxPrice: preferenceData.maxPrice,
        propertyTypes: Stdlib_Array.filterMap(Stdlib_Option.getOr(preferenceData.propertyTypes, []), v => forSalePropertyTypeEnumV5_decode(v)),
        areaGroup: areaGroup.fragmentRefs,
        chapter: chapter.fragmentRefs
      }) : undefined;
  } else {
    tmp = undefined;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(NotificationSettingsComponents.PreferenceSelectorForm.make, {
        title: "Buyer needs",
        text: JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            `You will always be notified of buyer needs that match your properties.`,
            JsxRuntime.jsx("br", {}),
            `Which other buyer need emails do you want to receive?`
          ]
        }),
        disabled: match[1],
        value: selectedSetting,
        onChange: v => {
          switch (v) {
            case "CUSTOM" :
              if (!hasGNSFeature) {
                return setShowUpgradeDialog(param => true);
              }
              if (!userHasInactiveCustomPreference) {
                return setIsEditing(param => true);
              }
              break;
            case "CHAPTER_DEFAULT" :
            case "MATCH_ONLY" :
              break;
          }
          updateUserNotificationSettings({
            input: {
              __$inputUnion: "buyerNeeds",
              _0: v
            }
          }, undefined, undefined, undefined, (param, param$1) => {
            let updateUserNotificationSettingsV5 = param.updateUserNotificationSettingsV5;
            if (updateUserNotificationSettingsV5 !== undefined && updateUserNotificationSettingsV5.__typename === "UserNotificationSettingsWasUpdated") {
              return onSuccess();
            } else {
              return onFailed();
            }
          }, undefined, undefined);
        },
        renderSummary: tmp,
        onPressEdit: () => {
          if (hasGNSFeature) {
            return setIsEditing(param => true);
          } else {
            return setShowUpgradeDialog(param => true);
          }
        },
        entityType: "BUYER_NEED"
      }),
      isEditing ? JsxRuntime.jsx(NotificationSettingsPreferenceEditDialog.make, {
          entityType: {
            NAME: "BUYER_NEED",
            VAL: Stdlib_Option.map(preferenceData, param => param.fragmentRefs)
          },
          chapter: chapter.fragmentRefs,
          settings: notificationSetting.fragmentRefs,
          isOpen: isEditing,
          onClose: () => setIsEditing(param => false)
        }) : null,
      JsxRuntime.jsx(NotificationSettingsComponents.UpgradeToProDialog.make, {
        isOpen: match$2[0],
        onClose: () => setShowUpgradeDialog(param => false)
      })
    ]
  });
}

let make = NotificationSettingsBuyerNeeds;

exports.NotificationSettingFragment = NotificationSettingFragment;
exports.ChapterFragment = ChapterFragment;
exports.UpdateUserNotificationSettingsV5Mutation = UpdateUserNotificationSettingsV5Mutation;
exports.make = make;
/* commitMutation Not a pure module */
